<template>
	<svg
		width="16"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		:class="{ 'cashout-indicator': 1, 'cashout-indicator--valid': canCashout }"
		v-if="$store.getters['cashout/whitelisted']"
	>
		<path
			d="M8 11.4C8 12.17 8.6 12.8 9.33 12.8H10.83C11.47 12.8 11.99 12.25 11.99 11.58C11.99 10.85 11.67 10.59 11.2 10.42L8.8 9.58001C8.32 9.41001 8 9.15001 8 8.42001C8 7.75001 8.52 7.20001 9.16 7.20001H10.66C11.4 7.21001 12 7.83001 12 8.60001"
			stroke="var(--black)"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10 12.85V13.59"
			stroke="var(--black)"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10 6.40997V7.18997"
			stroke="var(--black)"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M9.99 17.98C14.4028 17.98 17.98 14.4028 17.98 9.99C17.98 5.57724 14.4028 2 9.99 2C5.57724 2 2 5.57724 2 9.99C2 14.4028 5.57724 17.98 9.99 17.98Z"
			stroke="var(--black)"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M12.98 19.88C13.88 21.15 15.35 21.98 17.03 21.98C19.76 21.98 21.98 19.76 21.98 17.03C21.98 15.37 21.16 13.9 19.91 13"
			stroke="var(--black)"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	props: {
		betAmount: {
			type: Number,
			required: true,
		},
		totalOdds: {
			type: Number,
			required: true,
		},
		liveMatches: {
			type: Boolean,
			required: true,
		},
		areThereAnyInvalidMatches: {
			type: Boolean,
			required: true,
		},
		possibleWinnings: {
			type: Number,
			required: true,
		},
		bets: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			canCashout: false,
			cashoutMessage: null,
		};
	},
	watch: {
		totalOdds(n, o) {
			if (n) this.checkIfCanCashout();
		},
	},
	mounted() {
		this.checkIfCanCashout();
	},
	computed: {
		rules() {
			return this.$store.getters["cashout/settings"];
		},
	},
	methods: {
		betValidForCashout(sportID, subTypeID) {
			if (!this.rules || this.rules.length == 0) return false;

			const validSports = this.rules.find(
				(rule) => rule.rule_name == "sport"
			).rule_values;

			const validMarkets = this.rules.find(
				(rule) => rule.rule_name == "sub_type_id"
			).rule_values;

			return (
				validSports.indexOf(sportID) > -1 &&
				validMarkets.indexOf(subTypeID) > -1
			);
		},
		checkIfCanCashout() {
			let canCashout = true;
			let vm = this;
			vm.bets.forEach((bet) => {
				canCashout &= vm.betValidForCashout(bet.odd.sport_id, bet.sub_type_id);
			});
			vm.canCashout = canCashout;
		},
		checkIfCanCashoutFromAPI() {
			let vm = this;
			vm.cashoutMessage = null;
			if (this.areThereAnyInvalidMatches) {
				vm.canCashout = false;
				return;
			}
			let bets = vm.bets.map((b) => {
				return {
					bet_pick: b.odd.odd_key,
					parent_match_id: b.odd.parent_match_id.toString(),
					sub_type_id: b.sub_type_id.toString(),
					odd_value: b.odd.odd_value.toString(),
					special_bet_value: b.odd.special_bet_value,
					outcome_id: b.odd.outcome_id,
					reference: b.bet_type == "prebet" ? "PREMATCH_UOF" : "LIVEMATCH_UOF",
				};
			});
			let payload = {
				bet_amount: vm.betAmount,
				total_odd: vm.totalOdds,
				reference: vm.liveMatches ? "LIVEMATCH_UOF" : "PREMATCH_UOF",
				token: vm.$auth.getToken(),
				possible_win: vm.possibleWinnings,
				bet_slips: bets,
			};
			vm.$axios
				.post(`${BASE_V2_URL}cashout/validate`, payload)
				.then((res) => {
					vm.canCashout = res.data.status;
					vm.cashoutMessage = "Cashout will be available for this bet";
				})
				.catch((err) => {
					vm.canCashout = false;
					vm.cashoutMessage = err.response.data.message;
				});
		},
	},
};
</script>

<style lang="scss">
.cashout-indicator {
	stroke: var(--light-gray);
	margin: 0 2px;
	&--valid {
		stroke: var(--green);
	}
}
</style>
